import { ButtonFrame, CardSearch, PageBodyHeader, Table } from "../../component";
import { useEffect, useState } from "react";
import { UrlTypes, generalObj } from "../../constant/object_types";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { fetchStoreListByUserId } from "../../action/generalFunc";

const AdminOrderStoreList = () => {
    const { date, supervisor_id } = useParams();
    const navigate = useNavigate();
    const [storeList, setStoreList] = useState<generalObj[]>([]);
    const [searchText, setSearchText] = useState<string>("");

    const {setModalLoading}:{setModalLoading:Function} = useOutletContext();
    const account = useSelector((state:RootState) => state.account);
     
    useEffect(() => {
        if (!account || !account.isAuthenticated || !supervisor_id || !date) return;
        (async () => {
            let param_obj = { order_tracker: date.replaceAll("_", "-") };
            let result = await fetchStoreListByUserId(account.token, supervisor_id, "staff", param_obj);
            if (result) {
                setStoreList(result.data.stores);
            }else {
                window.history.back();
            }
            setModalLoading(false);
        })();
    }, [account, supervisor_id, date, setModalLoading]);

    const onSearch = (val:string) => {
        setStoreList((prevStoreList) => {
            return (
                prevStoreList.filter((item) => {
                    if (item.name.toLowerCase().includes(val.toLowerCase()) || item.organization.toLowerCase().includes(val.toLowerCase())) {
                        item.show = true;
                    }else {
                        item.show = false;
                    }
                    return item;
                })
            )
        })
        setSearchText(val);
    }

    const formatMonth = (month:string) => {
        if (!month) return "-";
        const [year, monthNumber] = month.split("-");
        const monthDate = new Date(Number(year), Number(monthNumber) - 1);
        return Number.isNaN(monthDate.getTime()) ? month : `${monthDate.toLocaleString("en-US", {month:"short"})} ${year}`;
    };

    // const processExport = (export_type:string) => {
    //     generateReport(export_type)
    // }

    // const generateReport = async (exportType:String) => {
    //     if (!exportType || !account || !account.isAuthenticated) return;

    //     setModalLoading(true);
    //     let param = {
    //         type: exportType
    //     };
        
    //     let result = await fetchStoreListReport(account.token, param);

    //     if (result && typeof(result) === "object") {
    //         const aElement = document.createElement('a');
    //         aElement.setAttribute('download', `store_list.${result.data.type.split("/")[1]}`);
    //         const href = URL.createObjectURL(result.data);
    //         aElement.href = href;
    //         aElement.setAttribute('target', '_blank');
    //         aElement.click();
    //         URL.revokeObjectURL(href);
    //         toast("Report generated");
    //     }
    //     setModalLoading(false);
    // }

    return (
        <>
            <PageBodyHeader title="Store List" desc="Check list of available Stores">
                <ButtonFrame btn_text="Back" btn_style={{padding:"8px 24px", borderRadius:"8px", border:"1px solid #808280",  backgroundColor:"#808280", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />
            </PageBodyHeader>

            <Table table_head={["Organization", "Store name", "Target", "Achieved", "Action"]} th_class="white" color={"#1159AB"} thColor={"#1159AB"} 
            tableSearch={<CardSearch value={searchText} onTextChange={(evt) => onSearch(evt)} />}
            // tableAction={<ExportData export_type={(val) => processExport(val)} />}
            headerStyle={{marginBottom: "44px"}}
            
            table_title={`Stores and Target for ${date ? formatMonth(date.replaceAll("_", "-")) : null}`}
            >
                <>
                    {storeList.map((item, index) => (
                        (item.show || item.show === undefined) && (
                            <tr key={index}>
                                <td>{item.organization}</td>
                                <td>{item.name}</td>
                                <td>{item.order_tracker.length > 0 ? item.order_tracker[0].target : 0}</td>
                                <td>{item.order_tracker.length > 0 ? item.order_tracker[0].achieved : 0}</td>
                                <td>
                                    <div style={{display:"flex", gap:"8px"}}>
                                    <button onClick={() => navigate(`${UrlTypes.ADMIN_ORDER_TARGET_MANAGE}${date?.replaceAll("_", "-")}/${supervisor_id}/${item.id}/`)} className={`status__container pending`} style={{width:"100px", padding:"5px"}}>Manage Target</button>
                                    <button onClick={() => navigate(`${UrlTypes.ADMIN_ORDER_TARGET_STORE_TRACKER}${date?.replaceAll("_", "-")}/${supervisor_id}/${item.id}/`)} className={`status__container completed`} style={{width:"100px", padding:"5px"}}>View Store Tracker</button>
                                    </div>
                                </td>
                            </tr>
                        )
                    ))}
                </>
            </Table>
        </>
    )
}

export default AdminOrderStoreList;